/**
 * Coordonnées géographiques approximatives du centre de chaque région française
 * Format: [latitude, longitude]
 * 
 * Ces coordonnées servent à positionner les marqueurs des utilisateurs du top 10
 * sur la carte de France.
 */

export const REGION_COORDINATES = {
    // France métropolitaine
    '84': [45.5000, 4.7000],     // Auvergne-Rhône-Alpes
    '27': [47.3000, 5.5000],     // Bourgogne-Franche-Comté  
    '53': [48.3905, -2.9285],    // Bretagne
    '24': [47.4716, 0.5514],     // Centre-Val de Loire
    '44': [49.2583, 4.0317],     // Grand Est
    '32': [50.6292, 3.0573],     // Hauts-de-France
    '11': [48.8566, 2.3522],     // Île-de-France
    '28': [49.0000, 0.3000],     // Normandie
    '75': [45.7000, 0.3000],     // Nouvelle-Aquitaine
    '76': [43.5928, 1.4438],     // Occitanie
    '52': [47.5000, -1.0000],    // Pays de la Loire
    '93': [43.9352, 6.0679],     // Provence-Alpes-Côte d'Azur
    '94': [42.2000, 9.1000],     // Corse (approximatif - entre 2A et 2B)

    // Départements d'outre-mer (DOM)
    '01': [16.2650, -61.5510],   // Guadeloupe
    '02': [14.6415, -61.0242],   // Martinique
    '03': [4.9228, -52.3260],    // Guyane
    '04': [-21.1151, 55.5364],   // La Réunion
    '06': [-12.8275, 45.1660],   // Mayotte
};

/**
 * Récupère les coordonnées d'une région à partir de son code
 * @param {string} regionCode - Code de la région (ex: '84', '11', etc.)
 * @returns {[number, number]|null} Coordonnées [lat, lng] ou null si non trouvé
 */
export function getRegionCoordinates(regionCode) {
    if (!regionCode) return null;
    return REGION_COORDINATES[regionCode] || null;
}

/**
 * Vérifie si une région a des coordonnées disponibles
 * @param {string} regionCode - Code de la région
 * @returns {boolean}
 */
export function hasRegionCoordinates(regionCode) {
    return regionCode && !!REGION_COORDINATES[regionCode];
}
